export enum LeadTagType {
  EXISTING_REFERRAL = "existing_referral",
  EXISTING_LEAD_TYPE = "existing_lead_type",
  EXISTING_LISTING = "existing_listing",
  LEAD_RECREATED = "lead_recreated",
  HOT_LEAD = "hot_lead",
}
